<template>
  <footer class="app-footer d-flex justify-content-center">
    <span>Wilco Docx &copy; {{currentYear}} <a href="http://wilcosource.com/"  target="_blank">Wilcosource LLC</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue